import { atom } from 'jotai';

/**
 * Type de l'utilisateur connecté, synchronisé depuis `useUser()` au niveau applicatif
 */
export const isInternalUserAtom = atom<boolean>(false);
